// extracted by mini-css-extract-plugin
module.exports = {"MerchantGlobalFooter":"MerchantGlobalFooter_MerchantGlobalFooter__1CxCx","StickyFooterPadding":"MerchantGlobalFooter_StickyFooterPadding__zbqGL"};